import { makeStyles } from "@material-ui/core";
import { grey, orange } from "@material-ui/core/colors";

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(3, 3, 2, 3),
    background: "white",
    width: "480px",
  },
  subtitle: {
    fontSize: "14px",
    color: grey["600"],
    lineHeight: "150%",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "150%",
  },
  warningText: {
    letterSpacing: "0.4px",
    lineHeight: "20px",
    color: orange[500],
    fontSize: "12px",
  },
  tagText: {
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "capitalize",
    lineHeight: "24px",
    color: grey["500"],
    // eslint-disable-next-line
    '&[data-selected="true"]': {
      color: "black",
    },
  },
  tagItem: {
    justifyContent: "space-between",
  },
  alertText: {
    color: grey[800],
    lineHeight: "150%",
  },
  tagList: {
    maxHeight: "388px",
    overflowY: "auto",
    /**
     * `overflowY: auto` computes `overflowX` to `auto` too, and MUI gives the
     * accordion's expand icon `edge="end"` (`marginRight: -12px`), which pokes
     * 4px past the summary's 8px right padding. That was enough for a
     * horizontal scrollbar over transparent icon padding.
     */
    overflowX: "hidden",
  },
  createNewTagButton: {
    width: "fit-content",
  },
}));

export default useStyles;
